import { Box, Button, Checkbox, Grid, Typography } from "@mui/material";
import {
  getPreferencesBasedOnUserId,
  updateOrgPreferences,
  updateUserWhatsAppConfig,
} from "api/notifications-preferences-service";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { ResType } from "types";
import AddPreferences from "./add-preferences";
import { snack } from "components/toast";
import BlockIcon from "@mui/icons-material/Block";
import Loader from "components/Loader";
import OrgPreferences from "./org-preference";
import { getOrganizationPreference } from "api/services/common";

const OrganizationPreference = () => {
  const params = useParams();
  const [preferenceData, setPreferenceData] = useState<any>({});
  const [userWhatsappPreferences, setUserWhatsappPreferences] = useState(false);
  const queryClient = useQueryClient();

  const {
    data: preferencedata,
    isLoading,
    error,
  }: ResType = useQuery(["get-user-preferences", params?.id], getOrganizationPreference, {
    onSuccess: (res: any) => {
      setPreferenceData(res?.data);
      setUserWhatsappPreferences(res?.data?.whatsappConfig);
    },
    cacheTime: 0,
  });

  const { mutate } = useMutation(updateOrgPreferences, {
    onSuccess: (res) => {
      snack.success("Whatsapp Preferences Updated");
      setPreferencesChanged(false);
      queryClient.invalidateQueries("get-user-preferences");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });
  const [preferencesChanged, setPreferencesChanged] = useState(false);
  const handleChange = () => {
    setUserWhatsappPreferences((prev) => !prev);
    setPreferencesChanged((prev) => !prev);
  };

  useEffect(() => {
    // Reset preferencesChanged when the component mounts
    setPreferencesChanged(false);
  }, []);

  const handleSave = async () => {
    setPreferencesChanged((prev) => !prev);
    // mutate({
    //   data: {
    //     id: preferenceData?.user?.id,
    //   },
    // });
  };

  if (isLoading) return <Loader />;

  return !preferencedata?.data ? (
    <>
      <Box minHeight="80vh" display="flex" justifyContent="center" alignItems="center">
        <Box p={2} borderRadius={2} minWidth={300} textAlign="center" bgcolor="rgb(253, 237, 237)">
          <BlockIcon
            fontSize="large"
            sx={{
              color: "rgb(95, 33, 32)",
            }}
          />
          <Typography variant="subtitle2" color="rgb(95, 33, 32)">
            Access Denied
          </Typography>
        </Box>
      </Box>
    </>
  ) : (
    <Box>
      {preferenceData && preferenceData && (
        <Box
          sx={{
            background: "#FBF9F2",
            borderRadius: "8px",
            p: 1,
            mb: 1,
          }}
        >
         
        </Box>
      )}
      {preferenceData && preferenceData && (
        <Box>
          <OrgPreferences data={preferenceData} />
        </Box>
      )}
    </Box>
  );
};

export default OrganizationPreference;
